// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WHD2uz56GQH8AKTmnfSG{padding-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationFilters/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".wrap {\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `WHD2uz56GQH8AKTmnfSG`
};
export default ___CSS_LOADER_EXPORT___;
